module.exports = __webpack_public_path__ + "img/logo.0b3ecb0a.jpg";